<template>
	<div>
		<c-input v-model="longitude" :name="lngName" type="hidden"></c-input>
		<c-input v-model="latitude" :name="latName" type="hidden"></c-input>
		<c-input v-model="region" name="_region" readonly placeholder="省、市、区/县" :disabled="disabled" @click.native="handle">
			<template #appendIcon>
				<i class="tf">&#xe6d7;</i>
			</template>
		</c-input>
		<c-input v-model="address" :name="addressName" placeholder="详细街道" :disabled="disabled" style="margin-top: .2rem;"></c-input>
	</div>
</template>

<script>
	export default {
		name: 'cLocation',

		props: {
			lngName: String,
			latName: String,
			addressName: String,
			disabled: Boolean
		},
		
		data() {
			return {
				longitude: '',
				latitude: '',
				region: '',
				address: ''
			}
		},

		computed: {
			lngLat() {
				return this.longitude && this.latitude ? `${this.longitude},${this.latitude}` : '';
			}
		},

		watch: {
			lngLat(val) {
				clearTimeout(this._timer);
				this._timer = setTimeout(() => {
					if (val) {
						this.request({
							url: '/location/analysis',
							data: {
								longitude: this.longitude,
								latitude: this.latitude
							},
							success: data => {
								this.longitude = data.longitude;
								this.latitude = data.latitude;
								this.region = `${data.province_name || ''}${data.city_name || ''}${data.county_name || ''}`;
							}
						});
					} else {
						this.longitude = this.latitude = this.region = this.address = '';
					}
					this.$emit('updateLngLat', val);
				}, 100);
			}
		},

		methods: {
			handle() {
				if (this.disabled) return;
				this.$onShow(async key => {
					let data = await this.getCacheData(key);
					if (data) {
						if (this.longitude != data.longitude || this.latitude != data.latitude) {
							this.address = data.address;
						}
						this.longitude = data.longitude;
						this.latitude = data.latitude;
					}
				}, true);

				this.mp.navigateTo('/pages/power/index', {
					power: 'chooseLocation',
					data: this.longitude && this.latitude ? `${this.longitude},${this.latitude}` : ''
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>